import {Typography} from '@mui/material';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {StyledCard, StyledUnOrderList} from './styles';

const {line1, line2, line3, line4, line5, line6, topics1, topics2} =
	translations['pt-br'].privateFlow.myHospitalization.information;

export const InformationCard = () => (
	<StyledCard>
		<Typography variant="body1">{line1}</Typography>
		<Typography variant="body1">
			<b>{line2.part1}</b>
			{line2.part2}
		</Typography>
		<br />
		<Typography variant="body1">
			<b>{line3}</b>
		</Typography>
		<Typography variant="body1">{line4}</Typography>
		<br />
		<Typography variant="body1">
			<b>{line5}</b>
		</Typography>
		<StyledUnOrderList>
			{Object.values(topics1).map((text, index) => (
				<li key={`${text}-${index}`}>
					<Typography variant="body1">{text}</Typography>
				</li>
			))}
		</StyledUnOrderList>
		<br />
		<Typography variant="body1">
			<b>{line6}</b>
		</Typography>
		<StyledUnOrderList>
			{Object.values(topics2).map((text, index) => (
				<li key={`${text}-${index}`}>
					<Typography variant="body1">{text}</Typography>
				</li>
			))}
		</StyledUnOrderList>
	</StyledCard>
);
